import { createElementObject, createPathComponent, extendContext, updateCircle } from './core';
import L from '@anlan/gs-map';
import type { CircleMarkerProps, LeafletContextInterface } from './core';
const LeafletCircleMarker = L.CircleMarker;
export const CircleMarker = createPathComponent(function createCircleMarker({ center, children, ...options }: CircleMarkerProps, ctx: LeafletContextInterface) {
    void children;
    const marker = new LeafletCircleMarker(center, options);
    return createElementObject(marker, extendContext(ctx, {
        overlayContainer: marker
    }));
}, updateCircle);
